<app-information-collector-by-payment [withButtons]="false" />
